import React, { useContext } from "react";
import "./reservation.css";
import { Tooltip } from "@material-ui/core";
import Swal from "sweetalert2";
import axios from "axios";
import Status from "./Status";
import { Context } from "../../context/Context";
const Reservation = ({ reservation, historyP }) => {
  const { token } = useContext(Context);
  const today = window.sessionStorage.getItem("data")
    ? window.sessionStorage.getItem("data")
    : new Date().toISOString().substr(0, 10);

  const email = `${reservation.email.substr(0, 20)}${
    reservation.email.length > 20 ? `...` : ""
  }`;
  const handleEdit = (
    descFirst,
    first,
    descSecond,
    second,
    descThird,
    third
  ) => {
    first = first ? first : "";
    second = second ? second : "";
    Swal.fire({
      title: "Edytuj rezerwację",
      html: `<input type="text" id="descFirst" class="swal2-input" value=${first}>
      <input type="text" id="descSecond" class="swal2-input" value=${second}>
      ${
        third
          ? `<input type="text" id="descThird" class="swal2-input" value=${third}>`
          : ""
      }
      `,
      confirmButtonText: "Zmień dane",
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonColor: "#1267a2",
      focusConfirm: false,
      preConfirm: () => {
        const descFirst = Swal.getPopup().querySelector(`#descFirst`).value;
        const descSecond = Swal.getPopup().querySelector("#descSecond").value;
        const descThird = third
          ? Swal.getPopup().querySelector("#descThird").value
          : "";
        if (descThird) {
          if (!descFirst || !descSecond || !descThird) {
            Swal.showValidationMessage(`Proszę wypełnić dane`);
          }
        } else {
          if (!descFirst || !descSecond) {
            Swal.showValidationMessage(`Proszę wypełnić dane`);
          }
        }
        return { descFirst, descSecond, descThird };
      },
    }).then((result) => {
      if (result.isConfirmed) {
        console.log(result);
        const changedDataFirst = {
          [descFirst]: result.value.descFirst,
          [descSecond]: result.value.descSecond,
        };
        const changedDataSecond = {
          [descFirst]: result.value.descFirst,
          [descSecond]: result.value.descSecond,
          [descThird]: result.value.descThird,
        };
        const change = async () => {
          await axios.put(
            `https://www.rezerwacjaparkingu.com/backend_artlot/api/reservations/${reservation._id}`,
            descThird ? changedDataSecond : changedDataFirst,
            {
              headers: {
                authorization: "megaparkingIGHERQHIGQRE " + token,
              },
            }
          );
        };
        change();
        Swal.fire({
          icon: "success",
          title: "Zapisano",
          confirmButtonText: `Ok`,
          confirmButtonColor: "#1267a2",
          denyButtonColor: "gray",
        }).then(() => {
          window.location.reload();
        });
      }
    });
  };
  const handleEditData = (first, second, third, four) => {
    Swal.fire({
      title: "Edytuj rezerwację",
      html: `<input type="date" id="arriveDate" class="swal2-input" value=${first}>
      <input type="text" id="arriveHour" class="swal2-input" value=${second}>
      <input type="date" id="leaveData" class="swal2-input" value=${third}>
      <input type="text" id="leaveHour" class="swal2-input" value=${four}>

      `,
      confirmButtonText: "Zmień datę",
      confirmButtonColor: "#1267a2",
      focusConfirm: false,
      showCancelButton: true,
      showCloseButton: true,
      cancelButtonText: "Anuluj",
      footer: `Zachowaj ":" pomiędzy godziną a minutami`,
      preConfirm: () => {
        const arriveHour = Swal.getPopup().querySelector("#arriveHour").value;
        const leaveHour = Swal.getPopup().querySelector("#leaveHour").value;
        const arriveData = Swal.getPopup().querySelector("#arriveDate").value;
        const leaveData = Swal.getPopup().querySelector("#leaveData").value;
        if (!arriveHour.includes(":") || !leaveHour.includes(":")) {
          Swal.showValidationMessage(`Godzina musi zawierać ":"`);
        }
        if (arriveHour.length !== 5 || leaveHour.length !== 5) {
          Swal.showValidationMessage(`Nieprawidłowy format daty`);
        }
        return {
          arriveHour: arriveHour.trim(),
          leaveHour: leaveHour.trim(),
          leaveData,
          arriveData,
        };
      },
    }).then((result) => {
      if (result.isConfirmed) {
        const changedData = {
          arriveData: result.value.arriveData,
          leaveData: result.value.leaveData,
          arriveHour: result.value.arriveHour,
          leaveHour: result.value.leaveHour,
        };
        const change = async () => {
          await axios.put(
            `https://www.rezerwacjaparkingu.com/backend_artlot/api/reservations/${reservation._id}`,
            changedData,
            {
              headers: {
                authorization: "megaparkingIGHERQHIGQRE " + token,
              },
            }
          );
        };
        change();
        Swal.fire({
          icon: "success",
          title: "Zapisano",
          confirmButtonText: `Ok`,
          confirmButtonColor: "#1267a2",
          denyButtonColor: "gray",
        }).then(() => {
          window.location.reload();
        });
      }
    });
  };
  return (
    <>
      <div
        className="reservation"
        style={
          reservation.arriveData === today
            ? { backgroundColor: "rgb(212, 255, 204)" }
            : {} && reservation.leaveData === today
            ? { backgroundColor: "rgb(255, 226, 226)" }
            : {}
        }
      >
        <div
          className="personalData"
          onClick={() =>
            handleEdit(
              "username",
              reservation.username,
              "surname",
              reservation.surname,
              "carId",
              reservation.carId
            )
          }
          title="Edytuj"
        >
          <span>
            {reservation.username} {reservation.surname}
          </span>
          <span>{reservation.carId}</span>
        </div>
        <div
          className="contactData"
          onClick={() =>
            handleEdit("email", reservation.email, "number", reservation.number)
          }
          title="Edytuj"
        >
          <Tooltip title={reservation.email} interactive>
            <span>{email}</span>
          </Tooltip>
          <span>{reservation.number}</span>
        </div>
        <div
          className="destinationData"
          onClick={() =>
            handleEdit(
              "destination",
              reservation.destination,
              "count",
              reservation.count
            )
          }
          title="Edytuj"
        >
          <span>{reservation.destination}</span>
          <span>
            Ilość osób: <span>{reservation.count}</span>
          </span>
        </div>
        <div
          className="companyData"
          onClick={() =>
            handleEdit(
              "companyName",
              reservation.companyName,
              "NIP",
              reservation.NIP
            )
          }
          title="Edytuj"
        >
          <span>
            Firma:{" "}
            {reservation.companyName ? reservation.companyName : "nie podano"}
          </span>
          <span>NIP: {reservation.NIP ? reservation.NIP : "nie podano"}</span>
        </div>
        <div
          className="arriveData"
          onClick={() =>
            handleEditData(
              reservation.arriveData,
              reservation.arriveHour,
              reservation.leaveData,
              reservation.leaveHour
            )
          }
          title="Edytuj"
        >
          <span>
            {reservation.arriveData}, {reservation.arriveHour}
          </span>
          <span>
            {reservation.leaveData}, {reservation.leaveHour}
          </span>
        </div>
        {reservation.isDone ? (
          <div className="statusData">
            <span style={{ color: "green", opacity: "0.7" }}>
              Operacja zakończona
            </span>
          </div>
        ) : (
          <Status reservation={reservation} />
        )}
      </div>
      <hr />
    </>
  );
};

export default Reservation;
